import { NavBar } from "../component/NavBar.jsx"
import { SideBar } from "../component/SideBar.jsx"

export const HelpPage = ()=>{
    return (
        <div>
        <NavBar/>
        <SideBar/>
        <div className="container">Help content </div>
        
        </div>
    )
};